import * as React from 'react';
import { BrowserRouter, Route, Link, Switch, Redirect, withRouter } from "react-router-dom";
import MedicineContainer from "../../components/medicines/medicineContainer";
import ManufacturerContainer from "../../components/configuration/manufacturers/manufacturerContainer";
import DiseaseContainer from "../../components/configuration/diseases/diseaseContainer";
import ActiveIngredientContainer from "../../components/configuration/activeIngredients/activeIngredientContainer";
import InactiveIngredientContainer from "../../components/configuration/inactiveIngredients/inactiveIngredientContainer";
import AtcCodesContainer from "../../components/configuration/atcCodes/atcCodesContainer";
import AnatomicalSystemContainer from "../../components/configuration/anatomicalSystem/anatomicalSystemContainer";
import DataSynchronizationContainer from "../configuration/dataSynchronization/dataSynchronizationContainer";
import Home from "../../components/home/home";
import AuthService from '../../services/authService';
import { Menubar } from 'primereact/menubar';
import FoodAlcoholContainer from '../configuration/foodAlcohol/foodAlcoholContainer';
import UserContainer from '../users/userContainer';
import DisposalPlacesContainer from '../disposalPlaces/disposalPlacesContainer';
import { connect } from 'react-redux';
import LogFilesContainer from '../configuration/logFiles/logFilesContainer';
import ConditionUnitType from '../configuration/conditionUnitType/conditionUnitTypeContainer';
import LoginComponent from '../login/loginComponent';

const NoMatch = () => (
  <div>
    <h3>
      URL address <code>{location.pathname}</code> not match.
    </h3>
  </div>
);

const auth = new AuthService();

interface Iprops {
  history: any
}

interface IState {
  activeMenuUrl: string
}

class Navigation extends React.Component<Iprops, IState> {
  redirect: boolean = false;
  menuItems = [
    {
      label: 'Home',
      command: () => { this.handleMenuItemClick('/') }
    },
    {
      label: 'Configuration',
      //icon: 'pi pi-fw pi-cog',
      items: [
        {
          label: 'Manufacturers',
          command: () => { this.handleMenuItemClick('/configuration/manufacturers') }
        },
        {
          label: 'ATC codes',
          command: () => { this.handleMenuItemClick('/configuration/atc-codes') }
        },
        {
          label: 'Inactive Ingredients',
          command: () => { this.handleMenuItemClick('/configuration/inactive-ingredients') }
        },
        {
          label: 'Foods and Alcohols',
          command: () => { this.handleMenuItemClick('/configuration/foodAlcohols') }
        },
        {
          label: 'Diseases',
          command: () => { this.handleMenuItemClick('/configuration/diseases') }
        },
        {
          label: 'Anatomical Systems',
          command: () => { this.handleMenuItemClick('/configuration/anatomical-systems') }
        },
        {
          label: 'Condition unit ranges',
          command: () => { this.handleMenuItemClick('/configuration/conditionUnitType') }
        }
      ]
    },
    {
      label: 'Active Ingredients',
      command: () => { this.handleMenuItemClick('/active-ingredients') }
    },
    {
      label: 'Medicines',
      command: () => { this.handleMenuItemClick('/medicines') }
    },
    {
      label: 'Users',
      command: () => { this.handleMenuItemClick('/users') }
    },
    {
      label: 'Disposal Places',
      command: () => { this.handleMenuItemClick('/disposalPlaces') }
    },
    {
      label: 'Data',
      items: [
        {
          label: 'EMA',
          command: () => { this.handleMenuItemClick('/data/emaSync') }
        },
        {
          label: 'BDA'
        }
      ]
    },
    {
      label: "System",
      items: [
        {
          label: 'Logs',
          command: () => { this.handleMenuItemClick('/system/logs') }
        }]
    }
  ];

  constructor(props) {
    super(props);
    this.state = {
      activeMenuUrl: ''
    }
  }

  handleMenuItemClick = (menuUrl) => {
    this.redirect = true;
    this.props.history.push(menuUrl);
    this.setState({ activeMenuUrl: menuUrl });
  }

  render() {

    const { activeMenuUrl } = this.state;

    if (this.redirect) {
      this.redirect = false;
      return <Redirect to={activeMenuUrl} />;
    }

    const isAuthenticated = auth.isAuthenticated() && auth.checkIsAdmin();

    return (
      <>
        {isAuthenticated ? <Menubar model={this.menuItems} /> : null}
        <div className="app-page">
          <div className="p-3">
            <Switch>
              <Route exact path="/" component={isAuthenticated ? Home : LoginComponent} />
              <Route exact path="/login" component={isAuthenticated ? Home : LoginComponent} />
              <Route path="/active-ingredients" component={isAuthenticated ? ActiveIngredientContainer : LoginComponent} />
              <Route path="/medicines" component={isAuthenticated ? MedicineContainer : LoginComponent} />
              <Route path="/users" component={isAuthenticated ? UserContainer : LoginComponent} />
              <Route path="/disposalPlaces" component={isAuthenticated ? DisposalPlacesContainer : LoginComponent} />
              <Route path="/configuration/manufacturers" component={isAuthenticated ? ManufacturerContainer : LoginComponent} />
              <Route path="/configuration/atc-codes" component={isAuthenticated ? AtcCodesContainer : LoginComponent} />
              <Route path="/configuration/inactive-ingredients" component={isAuthenticated ? InactiveIngredientContainer : LoginComponent} />
              <Route path="/configuration/foodAlcohols" component={isAuthenticated ? FoodAlcoholContainer : LoginComponent} />
              <Route path="/configuration/diseases" component={isAuthenticated ? DiseaseContainer : LoginComponent} />
              <Route path="/configuration/anatomical-systems" component={isAuthenticated ? AnatomicalSystemContainer : LoginComponent} />
              <Route exact path="/data/emaSync" component={isAuthenticated ? DataSynchronizationContainer : LoginComponent} />
              <Route exact path="/data/emaSync/:TabName" component={isAuthenticated ? DataSynchronizationContainer : LoginComponent} />
              <Route path="/system/logs" component={isAuthenticated ? LogFilesContainer : LoginComponent} />
              <Route path="/configuration/conditionUnitType" component={isAuthenticated ? ConditionUnitType : LoginComponent} />
              <Route component={NoMatch} />
            </Switch>
          </div>
        </div>

      </>
    )
  }
}

export default withRouter(connect()(Navigation));